/**
 * 시험항목 표시명 선택 규칙 — 단일 진실의 원천.
 *
 * 마스터(project_test_report_form)에는 이름이 둘 있다.
 *   name     = 벤조(a)피렌      (표시용)
 *   lab_name = Benzo(a)pyrene  (실험실용)
 *
 * 서버 makeSampleData(routes/v1/project/index.js)가 시료분석결과에 쓰는 규칙과
 * 같아야 한다. 수질만 lab_name 을 쓰고, 토양·대기·폐기물은 name 을 쓴다.
 * 전 분야 lab_name 우선으로 두면 토양 중금속 As 가 '비소'로 바뀌는 문제가 난다
 * (2026-07-13 커밋 bc5d14f).
 *
 * 이 규칙이 시료분석결과에만 적용되고 CCV 는 lab_name 우선으로 남아 있어서
 * 토양 벤조(a)피렌 일지에서 두 표의 시험항목명이 서로 달랐다(2026-08-05 재보고).
 * 이후로는 양쪽이 이 함수를 쓴다.
 */

/**
 * @param {{name?: string, lab_name?: string, category?: string}} item 마스터 행(또는 자식 항목)
 * @param {string} [category] 분야(SOIL/WATER/AIR/DISPOSAL). 없으면 item.category 사용
 * @returns {string}
 */
export function testItemDisplayName(item, category) {
	if (!item) return ''
	const cat = category || item.category
	if (cat === 'WATER') {
		const lab = item.lab_name
		if (lab != null && String(lab).trim() !== '') return String(lab).trim()
	}
	return item.name != null ? String(item.name).trim() : ''
}

/**
 * 시료 등록·고객사 시료의 **측정항목 목록** 표시명.
 *
 * 위 testItemDisplayName(시험일지)과는 고르는 컬럼이 다르다. 여기서 갈리는 건
 * name 과 search_name 이다.
 *   name        = BOD, CODMn, As      (현장 표기 — 이관 전 시스템이 쓰던 것)
 *   search_name = 생물화학적 산소요구량, 비소  (검색용 정식명)
 *
 * develop 에서 한때 search_name 을 무조건 앞세워 목록이 통째로 정식명으로 바뀌었다
 * (개발 DB 기준 수질 31건·토양 15건). 이관 전과 같이 name 이 기준이다.
 *
 * 폐기물만 예외로 search_name 을 먼저 쓴다. 원소분석 하위가
 * name=C/H/N/S/O/Cl 라 한 글자로는 구분이 안 되어 도입된 규칙이고,
 * 폐기물은 이관 전 시스템에 없어 맞출 기준이 따로 없다.
 *
 * @param {{name?: string, search_name?: string}} item
 * @param {string} category SOIL/WATER/AIR/DISPOSAL
 * @returns {string}
 */
export function specimenItemLabel(item, category) {
	if (!item) return ''
	return category === 'DISPOSAL'
		? item.search_name || item.name || ''
		: item.name || item.search_name || ''
}

export default testItemDisplayName
